'use strict';
angular.module('noticeGroupModule', []).controller('noticeGroupManageCtrl', noticeGroupManageCtrl);
noticeGroupManageCtrl.$inject = ['$scope', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'iwoNoticeService'];

/**
 * [noticeGroupManageCtrl 通知公告分组管理]
 *
 * @param   {[type]}  $scope           [$scope description]
 * @param   {[type]}  $modalInstance   [$modalInstance description]
 * @param   {[type]}  trsHttpService   [trsHttpService description]
 * @param   {[type]}  trsspliceString  [trsspliceString description]
 * @param   {[type]}  modalDialog      [modalDialog description]
 * @param   {[type]}  iwoNoticeService      [modalDialog description]
 *
 * @return  {[type]}                   [return description]
 */
function noticeGroupManageCtrl($scope, $modalInstance, trsHttpService, trsspliceString, modalDialog, iwoNoticeService) {

    /**
     * [initStatus 初始化状态]
     *
     * @return  {[type]}  [return description]
     */
    function initStatus() {
        $scope.data = {
            items: [],
            keyword: '',
            selectedArray: []
        };
    
        $scope.status = {
            jumpToPageNum: 1,
            startpage: 0,
        }
    
        $scope.page = {
            pn: 1, // 当前页
            PAGESIZE: 10, // globleParamsSet.getPageSize(),
            ITEMCOUNT: 0, // 总共多少数据
            PAGECOUNT: 0,
            startpage: 0
        };
    }
    
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.createGroup = function () {
        $scope.data.selectedArray = [];
        iwoNoticeService.createGroup().then(function(data) {
            $scope.page.pn = 1;
            $scope.status.jumpToPageNum = $scope.page.pn;
            $scope.page.startpage = $scope.page.pn - 1;
            requestData();
        });
    };

    $scope.delete = function(item) {
        var groupIds;
        modalDialog.confirmModal('删除', '确认删除选中的分组?', function() {
            if (!item) {
                groupIds = $scope.data.selectedArray.map((item) => item.LABELORGANIZATIONID).join(',');
            } else {
                groupIds = item.LABELORGANIZATIONID;
            }
            let params = {
                labelOrganizationIds: groupIds
            };
            $scope.data.selectedArray = [];
            $scope.loadingPromise = iwoNoticeService.deleteGroup(params).then((data) => {
                if (data.ISSUCCESS === 'true') {
                    modalDialog.alertType('', data.OPERATIONRESULT, 'success', false);
                } else {
                    modalDialog.alertType('删除失败', data.REASON, 'error', false);
                }
                requestData();
            });
        });
    };

    $scope.editGroup = function(group) {
        iwoNoticeService.createGroup(group).then(function() {
            requestData();
        });
    };

    /**
     * [requestData 请求数据]
     *
     * @param   {[type]}  ev  [ev description]
     *
     * @return  {[type]}      [return description]
     */
    $scope.requestData = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    }

    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.pn;
        $scope.page.startpage = $scope.page.pn - 1;
        requestData();
        $scope.data.selectedArray = [];
    };

    /**
     * [jumpToPage description] 跳转分页
     * @return {[type]} [description]
     */
    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        if ($scope.status.jumpToPageNum === '0' || isNaN(Number($scope.status.jumpToPageNum))) {
            modalDialog.alertType('请输入合法的页码', '', 'warning', false);
            return;
        }
        $scope.page.startpage = $scope.status.jumpToPageNum - 1;
        $scope.page.pn = $scope.status.jumpToPageNum;
        requestData();
        $scope.data.selectedArray = [];
    };

    /**
     * [checkSelect 判断是否选中]
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.checkSelect = function(item) {
        return $scope.data.selectedArray.some((_item) => _item.LABELORGANIZATIONID == item.LABELORGANIZATIONID);
    };

    /**
     * [selectCheckAdd description] 选中/取消选中元素
     * @param  {[type]} item [description] 元素
     * @return {[type]}      [description]
     */
    $scope.selectCheckAdd = function(item) {
        if ($scope.checkSelect(item)) {
            $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => _item.LABELORGANIZATIONID != item.LABELORGANIZATIONID);
        } else {
            $scope.data.selectedArray.push(item);
        }
    };

    /**
     * [selectAll description] 全选
     * @return {[type]} [description]
     */
    $scope.selectAll = function() {
        if ($scope.data.selectedArray.length == $scope.data.items.length && $scope.data.items.length > 0) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.items);
        }
    };

    initStatus();
    initData();

    /**
     * [initData 初始化数据]
     *
     * @return  {[type]}  [return description]
     */
    function initData() {
        requestData();
    }

    /**
     * [requestData 获取列表数据]
     *
     * @return  {[type]}  [return description]
     */
    function requestData() {
        const params = {
            keyWords: $scope.data.keyword || '',
            pageIndex: $scope.page.pn,
            pageSize: $scope.page.PAGESIZE,
        };
        $scope.loadingPromise = iwoNoticeService.getGroups(params).then((data) => {
            if (data.DATA) {
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.pn = data.PAGER.CURRPAGE;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
            }
        });
    }
}
